import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { isLoading } from 'e-submission/apps/selectors'

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1060;
`
export const Loading = (props) => {
  const { className } = props
  const state = useSelector((state) => state)

  const showLoading = isLoading(state)

  if (!showLoading) {
    return null
  }

  return (
    <Wrapper id="main-wrapper" className={className}>
      <div id="loader">
        <h6 className="status"></h6>
        <div id="spinner" />
      </div>
    </Wrapper>
  )
}
const LoadingLayout = Loading
export default LoadingLayout
